import { Schedule, APPOINTMENT_TYPES } from "@/types/schedule";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Edit, Trash2 } from "lucide-react";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface ScheduleCardProps {
  schedule: Schedule;
  onEdit: (schedule: Schedule) => void;
  onDelete: (id: string) => void;
}

export const ScheduleCard = ({
  schedule,
  onEdit,
  onDelete,
}: ScheduleCardProps) => {
  const appointmentTypeInfo = APPOINTMENT_TYPES[schedule.appointmentType];

  return (
    <div className="flex items-center justify-between p-4 bg-secondary rounded-lg border">
      <div className="flex items-start gap-3 flex-1">
        <div
          className={`px-3 py-1 rounded-md ${appointmentTypeInfo.bgColor}`}
        >
          <span className={`text-sm font-medium ${appointmentTypeInfo.color}`}>
            {schedule.startTime} - {schedule.endTime}
          </span>
        </div>

        <div className="space-y-1 flex-1">
          <div className="flex items-center gap-2">
            <Badge variant="outline">{appointmentTypeInfo.label}</Badge>
          </div>
          <p className="text-sm text-muted-foreground">
            {format(schedule.startDate, "dd/MM/yyyy", { locale: ptBR })} -{" "}
            {schedule.endDate
              ? format(schedule.endDate, "dd/MM/yyyy", { locale: ptBR })
              : "Indeterminado"}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-1">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onEdit(schedule)}
                className="hover:bg-primary/10 hover:text-primary"
              >
                <Edit className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>Editar horário</TooltipContent>
          </Tooltip>

          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                variant="ghost"
                size="icon"
                onClick={() => onDelete(schedule.id)}
                className="text-destructive hover:text-destructive hover:bg-destructive/10"
              >
                <Trash2 className="h-4 w-4" />
              </Button>
            </TooltipTrigger>
            <TooltipContent>Excluir horário</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </div>
  );
};

